export default "__VITE_ASSET__NcXGFKcQ__"